<app-breadcrumb></app-breadcrumb>
@if (cargaloader) {
  <div style="display: grid;place-content: center;">
    <img src="../../../assets/Animated/svg-loaders/bars.svg" alt="Cargando" loading="eager" decoding="async">
    <h6 style="color:#ccc">Cargando...</h6>
  </div>
}

@if (!cargaloader) {
  <div>
    @if (currentAccessoryLink) {
      <section class="accessory-callout" aria-labelledby="accessory-callout-title">
        <div>
          <span class="accessory-callout__eyebrow">Completa tu equipo</span>
          <h2 id="accessory-callout-title">Accesorios para {{ currentAccessoryLink.label }}</h2>
          <p>Encuentra estuches, mantenimiento, refacciones y más.</p>
        </div>
        <a class="accessory-callout__button" [routerLink]="accessoryPath()">
          <i class="bx bx-wrench" aria-hidden="true"></i>
          Ver accesorios
        </a>
      </section>
    }
    @if (MenuCategoriaImagenes.length > 0) {
      <nav class="mobile-subcategory-grid d-md-none my-3" aria-label="Subcategorías">
        @for (category of catHijasSlider; track category.IdCategoria) {
          <a class="mobile-subcategory-card" [routerLink]="subcategoryPath(category)">
            <img
              [src]="categoryImageUrl(category.Imagen)"
              [alt]="subcategoryLabel(category)"
              loading="lazy"
              decoding="async"
            />
            <span>{{ subcategoryLabel(category) }}</span>
          </a>
        }
      </nav>
      <div class="desktop-subcategory-slider d-none d-md-block my-3">
        <ng-image-slider #navSlider [images]="MenuCategoriaImagenes" [infinite]="false" [imagePopup]="false" [autoSlide]="false" [imageSize]="{maxWidth: '15%', height:'auto'}" slideImage="1" (imageClick)="imageClickHandler($event)">
        </ng-image-slider>
      </div>
    }
    <div class="d-flex flex-column flex-sm-row justify-content-between mb-3" [style.fontSize.px]="14">
      <div class="col-md-4 col-sm mb-2 mb-md-0">
        <div class="input-group input-group-sm" >
          <div class="input-group-prepend ">
            <label for="ordenarPor" class="input-group-text">Ordenar por:</label>
          </div>
          <select class="form-control form-control-sm" id="ordenarPor" [(ngModel)]="OrderSelected" (change)="Ordenar()">
            <option [value]="0">Destacados</option>
            <option [value]="1">Mayor Precio</option>
            <option [value]="2">Menor Precio</option>
            <option [value]="3">Marca</option>
          </select>
        </div>
      </div>
      <div class="col-md-4 col-sm">
        <div class="input-group input-group-sm" >
          <div class="input-group-prepend ">
            <label for="itemsPorPagina" class="input-group-text">Productos por página:</label>
          </div>
          <select class="form-control form-control-sm" id="itemsPorPagina" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{size}}</option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      @for (prod of currentItemsToShow; track prod; let i = $index) {
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="ProductGrid">
            <div class="ProductImage">
              <a [routerLink]="productPath(prod)" (click)="detalleProducto(prod)">
                @if (prod.Modelos.length > 0 && prod.Modelos[0].Imagenes.length > 0) {
                  <img class="pic-1 img-fluid" [src]="prod.Modelos[0].Imagenes[0].src" [alt]="prod.Nombre" [attr.loading]="i < 4 ? 'eager' : 'lazy'" [attr.fetchpriority]="i === 0 ? 'high' : 'auto'" decoding="async" />
                }
                @if (!(prod.Modelos.length > 0 && prod.Modelos[0].Imagenes.length > 0)) {
                  <img class="pic-1 img-fluid" src="Public/Img/Productos/Default.jpg" [alt]="prod.Nombre" loading="lazy" decoding="async" />
                }
              </a>
            </div>
            <div class="ProductContent">
              <div class="Mark">{{prod.Marca}}</div>
              <h3 class="Title"><a [routerLink]="productPath(prod)" (click)="detalleProducto(prod)" class="truncate-text">{{prod.Nombre}}</a></h3>
              @if (prod.Modelos.length > 0) {
                <div class="Price">{{ prod.Modelos[0].Precio | money }}</div>
              }
              @if (prod.Modelos.length == 0) {
                <div class="Price">{{ 0 | money }}</div>
              } </div>
              <ul class="Social">
                <li>
                  <a [routerLink]="productPath(prod)" (click)="detalleProducto(prod)" data-tip="Ver Producto">
                    <i class="fa fa-search"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        }
        @if (currentItemsToShow.length === 0 && !cargaloader) {
          <div class="col-12">
            <p class="text-center">No se encontraron productos que coincidan con tu búsqueda.</p>
          </div>
        }
      </div>
      @if (totalProductos > pageSize && !cargaloader) {
        <div class="d-flex justify-content-center mt-4">
          <nav aria-label="Paginación de productos">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" href="javascript:void(0);" (click)="onPageChangeManual(currentPage - 1)">
                  &laquo;
                </a>
              </li>
              @for (page of totalPagesArray(); track page) {
                <li class="page-item" [class.active]="page === currentPage">
                  <a class="page-link" href="javascript:void(0);" (click)="onPageChangeManual(page)">{{ page }}</a>
                </li>
              }
              <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" href="javascript:void(0);" (click)="onPageChangeManual(currentPage + 1)">
                  &raquo;
                </a>
              </li>
            </ul>
          </nav>
        </div>
      }
    </div>
  }
